import * as yup from 'yup';
import { eLenderFeeType } from '../../ui-toolkit/orders/interfaces/ILenderInformation';

const pageCountValidationFactory = () =>
  yup.object({
    lienRelease: yup.number().nullable().notRequired(),
    mortgage: yup.number().nullable().notRequired(),
    deed: yup.number().nullable().notRequired(),
    noticeOfSettlement: yup.number().nullable().notRequired(),
    subordinationAgreement: yup.number().nullable().notRequired(),
    assignment: yup.number().nullable().notRequired(),
  });

export const createLenderValidationFactory = () =>
  yup.object({
    name: yup.string().required(),
    address: yup.object({
      streetAddress: yup.string().required(),
      unit: yup.string().nullable().notRequired(),
      city: yup.string().required(),
      state: yup.string().required(),
      zip: yup.string().required(),
    }),
    mortgageeClause: yup.string().nullable().notRequired(),
    masterEmail: yup.string().nullable().notRequired(),
    wfgId: yup.string().nullable().notRequired(),
    bulkRateQualified: yup.boolean().required(),
    refiPremiumOrReportFee: yup.mixed<eLenderFeeType>().required(),
    refiDiscountedClosingFee: yup.boolean().required(),
    coBranded: yup.boolean().required(),
    logoUrl: yup
      .string()
      .notRequired()
      .nullable()
      .when('coBranded', { is: true, then: yup.string().required(), otherwise: yup.string().nullable().notRequired() }),
    refiPageCounts: pageCountValidationFactory(),
    purchasePageCounts: pageCountValidationFactory(),
  });

const temp = createLenderValidationFactory();
export type ILenderForm = yup.InferType<typeof temp>;
